import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DynamicGridFiltersConstants, DynamicGridFiltersState } from './dynamic-grid-filters.types';
import { RootState } from '@config/react-redux/store';

const { name } = DynamicGridFiltersConstants;
const initialState: DynamicGridFiltersState = {
    isOpen: false,
    showDueDates: false,
    voluntaryAttempts: true,
    showInstructionHubCorner: true,
    isCardViewOpen: false
};

export const dynamicGridFiltersSlice = createSlice({
    name,
    initialState,
    reducers: {
        setDynamicGridFiltersOpen (state, action: PayloadAction<boolean>) {
            state.isOpen = action.payload;
        },
        setShowDueDate (state, action: PayloadAction<boolean>) {
            state.showDueDates = action.payload;
        },
        setVoluntaryAttempts (state, action: PayloadAction<boolean>) {
            state.voluntaryAttempts = action.payload;
        },
        setIsCardViewOpen (state, action: PayloadAction<boolean>) {
            state.isCardViewOpen = action.payload;
        },
        setShowInstructionHubCorner (state, action: PayloadAction<boolean>) {
            state.showInstructionHubCorner = action.payload;
        }
    }
});

/**
 * ACTIONS
 */
export const {
    setDynamicGridFiltersOpen,
    setShowDueDate,
    setVoluntaryAttempts,
    setIsCardViewOpen,
    setShowInstructionHubCorner
} = dynamicGridFiltersSlice.actions;

/**
 * SELECTORS
 */
export const selectDynamicGridFiltersOpen = (state: RootState) => state[name].isOpen;

export const selectShowDueDates = (state: RootState) => state[name].showDueDates;

export const selectVoluntaryAttempts = (state: RootState) => state[name].voluntaryAttempts;

export const selectIsCardViewOpen = (state: RootState) => state[name].isCardViewOpen;

export const selectShowInstructionHubCorner = (state: RootState) => state[name].showInstructionHubCorner;

export default dynamicGridFiltersSlice.reducer;
